var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogIconDis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.331 5.09h-9.77a2.919 2.919 0 0 0-2.919 2.92v13.484a2.412 2.412 0 0 1-2.415 2.408h15.615a2.407 2.407 0 0 0 2.408-2.408V8.009a2.919 2.919 0 0 0-2.919-2.918zm-4.885 13.438h-4.094a.657.657 0 0 1 0-1.314h4.094a.657.657 0 0 1 0 1.314zm4.094-3.375h-8.188a.657.657 0 0 1 0-1.313h8.188a.657.657 0 0 1 0 1.313zm0-3.375h-8.188a.657.657 0 0 1 0-1.313h8.188a.657.657 0 0 1 0 1.313z",
    fill: "#ABABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.328 16.32v5.174c0 .604-.49 1.094-1.094 1.094h-.007a2.407 2.407 0 0 1-2.408-2.408v-.941a2.919 2.919 0 0 1 2.918-2.919h.591z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIconDis);
export default __webpack_public_path__ + "static/media/blogIcon-dis.ca2901361cbf60f5124e3d406f17897d.svg";
export { ForwardRef as ReactComponent };